/**
 * לוגו ממסך אדמין "חברות תעופה" (AppContext.airlines / saveAirlines).
 * התאמת קוד case-insensitive מול airline.code.
 */
export function findAdminAirline(airlines, airlineCode) {
  if (!airlineCode || !Array.isArray(airlines) || airlines.length === 0) {
    return null;
  }
  const c = String(airlineCode).trim().toUpperCase();
  return (
    airlines.find(
      (a) =>
        a &&
        a.code != null &&
        String(a.code).trim().toUpperCase() === c
    ) || null
  );
}

export function findAirlineLogoFromAdmin(airlines, airlineCode) {
  const logo = findAdminAirline(airlines, airlineCode)?.logo;
  if (logo == null || String(logo).trim() === "") return null;
  return String(logo);
}

/** Catalog display name for an IATA code. A name that is only the code counts as missing. */
export function findAirlineNameFromAdmin(airlines, airlineCode) {
  const row = findAdminAirline(airlines, airlineCode);
  const name = row?.name ?? row?.Name ?? row?.heName;
  if (name == null || String(name).trim() === "") return null;
  const trimmed = String(name).trim();
  const code = String(airlineCode || "").trim().toUpperCase();
  if (code && trimmed.toUpperCase() === code) return null;
  return trimmed;
}
